// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordExpiryDropdown_root___lazK","dropdownMenu":"PasswordExpiryDropdown_dropdownMenu__F7WVE"};